/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Dl_File_Mac_Cli_DescInputs */

const en_pc_dl_file_mac_cli_desc = /** @type {(inputs: Pc_Dl_File_Mac_Cli_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The headless CLI for scripts and agents.`)
};

const zh_pc_dl_file_mac_cli_desc = /** @type {(inputs: Pc_Dl_File_Mac_Cli_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`无界面 CLI，供脚本和 Agent 使用。`)
};

/**
* | output |
* | --- |
* | "The headless CLI for scripts and agents." |
*
* @param {Pc_Dl_File_Mac_Cli_DescInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_dl_file_mac_cli_desc = /** @type {((inputs?: Pc_Dl_File_Mac_Cli_DescInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Dl_File_Mac_Cli_DescInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_dl_file_mac_cli_desc(inputs)
	return zh_pc_dl_file_mac_cli_desc(inputs)
});
export { pc_dl_file_mac_cli_desc as "pc.dl.file.mac_cli.desc" }